<app-dialog [header]="'FEEDBACK.DIALOG.HEADER' | translate" [visible]="visible" (visibleChange)="onVisibleChange($event)" [modal]="true" [style]="{ width: '560px' }">
    <!-- Rebuilt on each open so no draft or validation state survives a close. -->
    @if (visible) {
        <form [formGroup]="form" class="flex w-full flex-col items-start gap-(--spacing-layout-l)">
            <p class="text-body-large text-bodyText">{{ 'FEEDBACK.DIALOG.DESCRIPTION' | translate }}</p>

            @if (contextLabel) {
                <div class="rounded-4 bg-surface-50 text-caption text-secondaryLabel w-full px-3 py-2">{{ 'FEEDBACK.DIALOG.CONTEXT_LABEL' | translate }}: {{ contextLabel }}</div>
            }

            <div class="w-full">
                <app-select formControlName="category" [label]="'FEEDBACK.DIALOG.CATEGORY' | translate" [options]="categoryOptions()" optionLabel="label" optionValue="value" [fluid]="true" appendTo="body" inputId="feedback-category" />
            </div>

            <div class="w-full">
                <app-input
                    type="textarea"
                    formControlName="description"
                    [label]="'FEEDBACK.DIALOG.DESCRIPTION_LABEL' | translate"
                    id="feedback-description"
                    [rows]="5"
                    [fluid]="true"
                    [maxLength]="4000"
                    [showCharCount]="true"
                    [helpText]="'FEEDBACK.DIALOG.DESCRIPTION_HINT' | translate"
                />
            </div>

            <div class="flex w-full flex-col gap-2">
                <label class="text-body-medium text-headingText">{{ 'FEEDBACK.DIALOG.ATTACHMENT' | translate }}</label>
                <app-file-uploader formControlName="attachment" [multiple]="false" accept="image/*,.pdf" />
            </div>

            <div class="flex w-full justify-end gap-(--spacing-layout-l)">
                <app-button [label]="'GENERIC.CANCEL' | translate" variant="secondary" type="button" (onClick)="close()" />
                <app-button [label]="'GENERIC.SUBMIT' | translate" variant="primary" type="button" [loading]="_feedbackService.submitting()" [disabled]="_feedbackService.submitting()" (onClick)="submit()" />
            </div>
        </form>
    }
</app-dialog>
